import { Icon, IconProps } from './Icon';

export type CrossProps = IconProps;

const Cross = (props: CrossProps) => (
  <Icon fill="none" viewBox="0 0 18.7 18.7" {...props}>
    <path
      fill="currentColor"
      d="M15.135.479 9.35 6.264 3.565.48a1.637 1.637 0 0 0-2.315 0L.48 1.25a1.637 1.637 0 0 0 0 2.315L6.264 9.35.48 15.135a1.637 1.637 0 0 0 0 2.315l.771.771a1.637 1.637 0 0 0 2.315 0l5.785-5.786 5.785 5.786a1.637 1.637 0 0 0 2.315 0l.77-.771a1.637 1.637 0 0 0 0-2.315L12.437 9.35l5.785-5.785a1.637 1.637 0 0 0 0-2.315L17.45.48a1.637 1.637 0 0 0-2.315 0z"
    />
  </Icon>
);

export { Cross };
